import React, { useState, useEffect, useMemo } from 'react';
import { Newspaper, Clock, Zap, Filter, AlertCircle, Loader } from 'lucide-react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);
reportWebVitals();
